import { actionCreators, ModalMessage } from "../reducers/modalMessage";
import { AppDispatch } from "../../index";

export const showModalMessage = (modalMessage: ModalMessage) => (dispatch: AppDispatch) =>
    dispatch(actionCreators.show(modalMessage));
